import { TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
}));

export function AdvertisementTextField(props) {
  const classes = useStyles();
  const { label, multiline, onChange, type } = props;

  return (
    <TextField
      id="normal-field"
      className={classes.root}
      label={label}
      multiline={multiline}
      onChange={onChange}
      type={type}
      variant="outlined"
      inputProps={{
        style: {
          height: "135px",
        },
      }}
    />
  );
}

AdvertisementTextField.propTypes = {
  label: PropTypes.string,
  multiline: PropTypes.bool,
  onChange: PropTypes.func,
  type: PropTypes.string,
};
